module.exports = __webpack_public_path__ + "static/img/200117.0e0ad2f0.png";